import React from 'react';
import tecno from '../../Tecno-list/tecno';
import { Link } from 'react-router-dom';

function Cinegon() {

    return (
        <React.Fragment>
            <section className='Proyect'>

                <h2 className="">Cinegon</h2>
                <div className='folder-porfolio'>

                    <iframe src="https://www.youtube.com/embed/vduaXbgnnLw" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>

                    <div className="list" >

                        {tecno.filter(tec => tec.T === 'Oracle' || tec.T === 'C#').map(tec => (

                            <div key={tec.T}>

                                <a href={tec.L} target="_blank" rel="noreferrer">

                                    <button className="etiqueta">  <p> <span>&#183;</span> {tec.T}</p></button>
                                </a>
                            </div>

                        ))}
                    </div>

                    <p className='white'>
                        This version of the application created with C # allows you to upload movies to an oracle database,
                        store their cover images and then display them on the screen.
                    </p>

                    <a href="https://github.com/BrandonGrimaldoM/Cinegon" target="_blank" rel="noreferrer">
                        <button className="Git"> <p>Repository </p> <div className="gitIcon"></div> </button>
                    </a>
                </div>
                <div className='after'>
                    <Link to="/desktop" className="Link">  <div className='iconAfter'>  <p className='flecha'>←</p></div>  </Link>
                </div>
            </section>
        </React.Fragment>
    );
}
export default Cinegon;